import React, { useMemo } from 'react'
import { Controller, useForm } from 'react-hook-form'
import Select from 'react-select'
import countryList from 'react-select-country-list'

const CountrySelect = ({ id, validation, control }) => {
  const options = useMemo(() => countryList().getData(), [])

  const customStyles = {
    control: (base) => ({
      ...base,
      border: 'none', // Remove borders
      boxShadow: 'none', // Remove focus shadow
      color: 'black',
      '&:hover': {
        border: 'none', // Remove hover border
      },
    }),
    input: (base) => ({
      ...base,
      boxShadow: 'none', // Remove focus shadow on input
      outline: 'none', // Remove focus outline
      caretColor: 'black', // Optional: Removes the blinking cursor if needed
      color: 'black',
      '&:focus': {
        outline: 'none', // Remove outline from dropdown indicator
        ring: 'none',
      },
    }),
    valueContainer: (base) => ({
      ...base,
      padding: 0, // Adjust padding if needed
      color: 'black',
    }),
    menu: (base) => ({
      ...base,
      border: 'none', // Remove menu border
      boxShadow: 'none', // Remove menu shadow
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? '#f0f0f0' : 'white', // Change focus background color
      color: 'black',
    }),
    dropdownIndicator: (base) => ({
      ...base,
      color: 'black',
      '&:focus': {
        outline: 'none', // Remove outline from dropdown indicator
        boxShadow: 'none',
      },
    }),
    indicatorSeparator: () => ({
      display: 'none', // Remove the separator between input and dropdown arrow
    }),
    clearIndicator: (base) => ({
      ...base,
      color: 'black',
      '&:focus': {
        outline: 'none', // Remove outline from clear indicator
        boxShadow: 'none',
      },
    }),
  }

  return (
    <div className="country-select w-full px-0 border-0 border-b border-primary focus:outline-none focus:ring-0 focus:border-b-1 focus:border-primary">
      <Controller
        name={id}
        control={control}
        rules={validation} // Validation rules like "required"
        render={({ field, fieldState }) => (
          <>
            <Select
              {...field}
              options={options}
              value={options.find((option) => option.value === field.value)} // Keep the selected value updated
              onChange={(selectedOption) =>
                field.onChange(selectedOption ? selectedOption.value : '')
              }
              placeholder={`Select your ${id}`}
              styles={customStyles} // Apply custom styles to remove borders and outline
            />
            {fieldState.error && (
              <span style={{ color: 'red' }}>{fieldState.error.message}</span>
            )}
          </>
        )}
      />
    </div>
  )
}

export default CountrySelect
